import { gql } from "@apollo/client";

export const GET_BOOKING = gql`
  query bandBooking($id: String) {
    bandBooking(where: { id: $id }) {
      id
      announcementId
      announcement {
        id
        editionId
      }
      edition {
        id
      }
      band {
        id
        name
      }
      stage {
        id
        name
      }
      date
      duration
      startTime
      endTime
    }
  }
`;

export const UPDATE_BOOKING = gql`
  mutation updateBooking(
    $id: String!
    $startTime: String
    $endTime: String
    $date: String
    $stageId: String
    $announcementId: String
    
  ) {
    updateBandBooking(
      bandBooking: {
        id: $id
        startTime: $startTime
        endTime: $endTime
        date: $date
        stageId: $stageId
        announcementId: $announcementId
      }
    ) {
      id
      band {
        id
        name
      }
      announcementId
      date
      duration
      startTime
      endTime
      stage {
        name
      }
    }
  }
`;

export const DELETE_BOOKING = gql`
  mutation deleteBandBooking($bookingId: String!) {
    deleteBandBooking(bookingId: $bookingId) {
      id
    }
  }
`;

export const CREATE_BOOKING = gql`
  mutation createBooking(
    $bandId: String!
    $startTime: String
    $announcementId: String
    $stageId: String
    $endTime: String
    $date: String
    $editionId: String
  ) {
    createBandBooking(
      bandId: $bandId
      startTime: $startTime
      announcementId: $announcementId
      stageId: $stageId
      endTime: $endTime
      date: $date
      editionId: $editionId
    ) {
      id
    }
  }
`;
